/** HDR lighting is resolved last: a sequence can never dim a kick. */
export function lightBarRadiance(sequence: number, kick: number) {
  return Math.max(Math.pow(sequence, 0.72) * 4.2, kick * 12);
}

/** Depth is measured in frame spacings, with zero at the front frame. */
export function kickWaveAtDepth(age: number, depth: number, farthest: number) {
  if (age < 0 || !Number.isFinite(age + depth + farthest)) return 0;
  const remaining = farthest > 0 ? Math.max(0, Math.min(1, depth / farthest)) : 0;
  // Inverse of easeOutQuad: equal distances take progressively longer.
  // The crest crosses the entire current depth span in 180 ms.
  const arrival = 0.18 * (1 - Math.sqrt(remaining));
  const offset = age - arrival;
  // A short attack and a time-based tail keep fast distant flashes visible.
  const width = offset < 0 ? 0.014 : 0.045;
  return Math.exp(-offset * offset / (2 * width * width));
}
